import axios from "axios";

export async function isAuthenticated() {
    const {data} = await axios.get('/api/v2/users/isAuthenticated');

    if (data.isAuthenticated) {
        return {
            isAuthenticated: true,
            uid: data.uid
        };
    } else {
        return {
            isAuthenticated: false
        };
    }
}